<!-- Icon set. Inline rather than registered assets: they are 20px glyphs used
     only here, and the first-screen icon work already established that a
     round trip per glyph is not worth paying. -->
<ng-template #icon let-name>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <ng-container [ngSwitch]="name">
      <ng-container *ngSwitchCase="'overview'">
        <rect x="3" y="3" width="7.5" height="7.5" rx="2" />
        <rect x="13.5" y="3" width="7.5" height="7.5" rx="2" />
        <rect x="3" y="13.5" width="7.5" height="7.5" rx="2" />
        <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2" />
      </ng-container>
      <ng-container *ngSwitchCase="'people'">
        <circle cx="9" cy="8" r="3.2" />
        <path d="M3.5 19.5c.7-3 2.9-4.6 5.5-4.6s4.8 1.6 5.5 4.6" />
        <path d="M16 5.2a3.2 3.2 0 0 1 0 5.9M17.5 15.2c2 .5 3.3 2 3.8 4.3" />
      </ng-container>
      <ng-container *ngSwitchCase="'business'">
        <rect x="3" y="7.6" width="18" height="12.6" rx="2" />
        <path d="M9 7.6V6a1.8 1.8 0 0 1 1.8-1.8h2.4A1.8 1.8 0 0 1 15 6v1.6" />
        <path d="M3 12.6h18" />
      </ng-container>
      <ng-container *ngSwitchCase="'traffic'">
        <path
          d="M4 15.5v-3.2l1.8-4.5A1.8 1.8 0 0 1 7.5 6.6h9a1.8 1.8 0 0 1 1.7 1.2l1.8 4.5v3.2a1.6 1.6 0 0 1-1.6 1.6H5.6A1.6 1.6 0 0 1 4 15.5Z"
        />
        <path d="M4.5 12.3h15" />
        <path d="M6.5 17.1v1.6M17.5 17.1v1.6" />
        <circle cx="7.6" cy="14" r=".4" />
        <circle cx="16.4" cy="14" r=".4" />
      </ng-container>
      <ng-container *ngSwitchCase="'wealth'">
        <circle cx="12" cy="12" r="9" />
        <path
          d="M12 6.8v10.4M14.6 9.3c-.6-.7-1.6-1-2.6-1-1.5 0-2.6.8-2.6 2s1 1.7 2.6 2c1.7.3 2.7.8 2.7 2s-1.2 2-2.7 2c-1.1 0-2.1-.4-2.7-1.1"
        />
      </ng-container>
      <ng-container *ngSwitchCase="'health'">
        <path
          d="M20.4 6.9a4.7 4.7 0 0 0-7.1-.6l-1.3 1.3-1.3-1.3a4.7 4.7 0 0 0-7.1.6c-1.2 1.8-.9 4.3.7 5.9l7.7 7.6 7.7-7.6c1.6-1.6 1.9-4.1.7-5.9Z"
        />
      </ng-container>
      <ng-container *ngSwitchCase="'trends'">
        <path d="M3 16.5 9 10l4 4 8-8" />
        <path d="M15 6h6v6" />
      </ng-container>
      <ng-container *ngSwitchCase="'home'">
        <path d="M3.5 10.5 12 3.8l8.5 6.7" />
        <path d="M5.6 12.2v7.4a1 1 0 0 0 1 1h10.8a1 1 0 0 0 1-1v-7.4" />
        <path d="M9.8 20.6v-5.4h4.4v5.4" />
      </ng-container>
      <ng-container *ngSwitchCase="'heart'">
        <path d="M3.5 12.5h3.8l1.6-3.6 2.6 7.6 2.3-5.4 1.2 1.4h5.1" />
      </ng-container>
    </ng-container>
  </svg>
</ng-template>

<!-- "Click this one." Shown only while the getting-started guide is pointing
     at a row, in place of whatever glyph that row normally carries. -->
<ng-template #guideCursor>
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M9 4 18 12.6l-4.2.3 1.8 4.2-2.2.9-1.8-4.2-3 2.9z"
      fill="currentColor"
    />
    <path
      d="M6.6 3.2 5.1 1.7M4.2 5.6 2.1 5.1M5.2 9 3.7 10.5"
      fill="none"
      stroke="currentColor"
      stroke-width="1.7"
      stroke-linecap="round"
    />
  </svg>
</ng-template>

<!-- Marks a row that repaints the map. Two stacked sheets: the same idea the
     map's own layer control uses. -->
<ng-template #mapGlyph>
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M8 1.9 1.9 5.2 8 8.5l6.1-3.3L8 1.9Z" />
    <path d="M2.4 8.5 8 11.5l5.6-3" />
  </svg>
</ng-template>

<!-- One row: name and number on the top line, the gap from the US underneath. -->
<ng-template #metric let-row>
  <button
    type="button"
    class="metric metric--locked"
    *ngIf="row.lock"
    [class.is-free-lock]="row.lock.free"
    (click)="handleLockedClick(row)"
    [attr.data-cy]="'popup-locked-metric'"
    [attr.aria-label]="row.lock.aria + ' ' + row.label"
  >
    <span class="metric__head">
      <span class="metric__label">{{ row.label }}</span>
      <span class="metric__redacted" aria-hidden="true"></span>
    </span>
    <span class="metric__foot">
      <span class="metric__ref metric__ref--unlock">
        <span class="metric__lock">
          <svg appLockIcon></svg>
        </span>
        {{ row.lock.phrase }}
      </span>
    </span>
  </button>

  <!-- A readable metric the map has a layer for: the row is the control that
       switches to it, so the number and the map agree without a trip to the
       right menu. -->
  <button
    type="button"
    class="metric metric--action"
    *ngIf="!row.lock && row.colorable"
    [class.is-on-map]="row.onMap"
    [class.guide-highlight]="guidedFeature === row.feature"
    [class.guide-highlight-pulse]="guidedFeature === row.feature && guidedPulse"
    [title]="row.note"
    [disabled]="row.onMap"
    (click)="handleColorByClick(row)"
    [attr.data-cy]="'popup-metric-action'"
    [attr.aria-label]="
      row.onMap
        ? row.label + ', on the map now'
        : 'Color the map by ' + row.label
    "
  >
    <ng-container
      *ngTemplateOutlet="metricBody; context: { $implicit: row }"
    ></ng-container>
  </button>

  <div
    class="metric"
    *ngIf="!row.lock && !row.colorable"
    [title]="row.note"
    [class.guide-highlight]="guidedFeature === row.feature"
    [class.guide-highlight-pulse]="guidedFeature === row.feature && guidedPulse"
  >
    <ng-container
      *ngTemplateOutlet="metricBody; context: { $implicit: row }"
    ></ng-container>
  </div>
</ng-template>

<!-- Shared by the two renderings above: only the element around it changes. -->
<ng-template #metricBody let-row>
  <span class="metric__head">
    <span class="metric__label">{{ row.label }}</span>
    <span class="metric__cursor" *ngIf="guidedFeature === row.feature">
      <ng-container *ngTemplateOutlet="guideCursor"></ng-container>
    </span>
    <span class="metric__flag" *ngIf="row.onMap">on the map</span>
    <span class="metric__paint" *ngIf="row.colorable && !row.onMap">
      <ng-container *ngTemplateOutlet="mapGlyph"></ng-container>
    </span>
    <span
      class="metric__value"
      [class.is-pending]="row.pending"
      [attr.aria-busy]="row.pending ? 'true' : null"
      [style.color]="row.grade ? row.grade.ink : null"
      >{{ row.pending ? '···' : row.value }}</span
    >
  </span>

  <!-- An index is already a ratio to the country, so there is no national tick
       to draw it against: it gets the score block's meter, filled by the same
       grade ramp, and the empty delta slot keeps its right edge in line with
       the bars on the rows around it. -->
  <span class="metric__foot" *ngIf="row.grade">
    <span class="meter__track meter__track--row">
      <span
        class="meter__fill"
        [style.width.%]="row.grade.fill"
        [style.background]="row.grade.base"
      ></span>
    </span>
    <span class="metric__delta" aria-hidden="true"></span>
    <span class="metric__ref">Graded against the US</span>
  </span>

  <span class="metric__foot" *ngIf="row.deviation && !row.grade">
    <span class="bar">
      <span class="bar__tick"></span>
      <span
        class="bar__fill"
        [ngClass]="'is-' + row.deviation.polarity"
        [style.left.%]="fillOffset(row.deviation)"
        [style.width.%]="fillWidth(row.deviation)"
      ></span>
    </span>
    <span class="metric__delta" [ngClass]="'is-' + row.deviation.polarity">
      {{ row.deviation.label }}
    </span>
    <span class="metric__ref">{{ row.reference }}</span>
  </span>
</ng-template>

<!-- Two figures rather than the right menu's AADT chart, which is too wide
     for this card. -->
<ng-template #trafficCard>
  <button
    type="button"
    class="inset traffic--locked"
    *ngIf="trafficLock"
    [class.is-free-lock]="trafficLock.free"
    (click)="handleTrafficLockedClick()"
    [attr.data-cy]="'popup-traffic-locked'"
    [attr.aria-label]="trafficLock.aria + ' the daily traffic on roads here'"
  >
    <span class="traffic__lead">
      <span class="metric__redacted" aria-hidden="true"></span>
      <span class="traffic__unit">veh/day</span>
      <span class="traffic__caption">on an average mile of road here</span>
    </span>
    <span class="inset__unlock">
      <span class="metric__lock">
        <svg appLockIcon></svg>
      </span>
      {{ trafficLock.phrase }}
    </span>
  </button>

  <ng-container *ngIf="!trafficLock" [ngSwitch]="trafficState">
    <p class="inset inset--aside" *ngSwitchCase="'loading'">
      Counting the vehicles on the roads here&hellip;
    </p>

    <p
      class="inset inset--aside"
      *ngSwitchCase="'empty'"
      [attr.data-cy]="'popup-traffic-empty'"
    >
      No road traffic counts for this area - nothing here has been surveyed, or
      the cell has no mapped roads in it.
    </p>

    <p
      class="inset inset--aside"
      *ngSwitchCase="'failed'"
      [attr.data-cy]="'popup-traffic-failed'"
    >
      Traffic counts could not be loaded for this area. Reopen the cell to try
      again.
    </p>

    <div
      class="inset"
      *ngSwitchCase="'ready'"
      [attr.data-cy]="'popup-traffic-card'"
    >
      <p class="traffic__lead">
        <b class="traffic__value">{{ trafficOverall }}</b>
        <span class="traffic__unit">veh/day</span>
        <span class="traffic__caption">on an average mile of road here</span>
      </p>
      <p class="traffic__split">{{ trafficSplit }}</p>
      <p class="inset__note">
        Annual average daily traffic, weighted by how much of each road type
        runs through this area; driveways and parking aisles left out. Source:
        Ticon.
      </p>
    </div>
  </ng-container>
</ng-template>

<!-- Four cohorts rather than the right menu's age pyramid; computed by
     customer-profile/generations.ts. -->
<ng-template #generationsCard>
  <ng-container [ngSwitch]="generationsState">
    <p class="inset inset--aside" *ngSwitchCase="'loading'">
      Sorting the people here into generations&hellip;
    </p>

    <p
      class="inset inset--aside"
      *ngSwitchCase="'empty'"
      [attr.data-cy]="'popup-generations-empty'"
    >
      No age breakdown is published for this area, so the generations behind its
      population cannot be told apart.
    </p>

    <p
      class="inset inset--aside"
      *ngSwitchCase="'failed'"
      [attr.data-cy]="'popup-generations-failed'"
    >
      The generation mix could not be loaded for this area. Reopen the cell to
      try again.
    </p>

    <div
      class="inset"
      *ngSwitchCase="'ready'"
      [attr.data-cy]="'popup-generations-card'"
    >
      <!-- Explicit roles: `display: contents` rows drop list semantics. -->
      <ul class="gens__list" role="list">
        <!-- Locked rows keep name and ages; only the count is withheld. -->
        <li
          class="gens__row"
          role="listitem"
          *ngFor="let generation of generations; trackBy: trackById"
          [class.is-locked]="isGenerationLocked(generation)"
        >
          <span class="gens__name">
            {{ generation.label }}
            <span class="gens__age">{{ generation.ageLabel }}</span>
          </span>

          <ng-container *ngIf="!isGenerationLocked(generation); else redacted">
            <span class="gens__bar" aria-hidden="true">
              <span
                class="gens__fill"
                [style.width.%]="generation.share * 100"
              ></span>
            </span>
            <span class="gens__value">
              {{ formatGenerationPeople(generation.people) }}
              <span class="gens__share">
                {{ formatGenerationShare(generation.share) }}
              </span>
            </span>
          </ng-container>

          <ng-template #redacted>
            <span
              class="metric__redacted gens__redacted"
              role="img"
              [attr.aria-label]="
                generationsLock!.aria +
                ' how many ' +
                generation.label +
                ' live here'
              "
            ></span>
          </ng-template>
        </li>
      </ul>

      <button
        type="button"
        class="inset__unlock"
        *ngIf="generationsLock"
        [class.is-free-lock]="generationsLock.free"
        (click)="handleGenerationsLockedClick()"
        [attr.data-cy]="'popup-generations-locked'"
        [attr.aria-label]="
          generationsLock.aria + ' the rest of the generation mix'
        "
      >
        <span class="metric__lock">
          <svg appLockIcon></svg>
        </span>
        {{ generationsLock.phrase }}
      </button>

      <!-- Said because the shares visibly do not add to 100%. -->
      <p class="inset__note">
        Residents by birth cohort, from the {{ generationsYear }} age
        distribution. Children younger than Gen Z and the generations before the
        Boomers are counted in the population but not shown here.
      </p>
    </div>
  </ng-container>
</ng-template>

<h4 class="place" [class.has-kind]="!!subtitle">{{ title }}</h4>
<p class="place-kind" *ngIf="subtitle" [attr.data-cy]="'popup-area-kind'">
  {{ subtitle }}
</p>

<!-- Above the tabs, not inside Overview: it qualifies every number in every
     tab, so it has to stay on screen whichever one is open. -->
<p class="caution" *ngIf="isMostlyWater">
  Mostly water. The numbers cover the administrative area around this cell.
</p>
<p class="caution" *ngIf="isTinyPopulation">
  Fewer than 10 residents. Read the demographics with care.
</p>

<!-- Subjects across, detail below. -->
<nav class="tabs" role="tablist" [attr.data-cy]="'popup-tabs'">
  <button
    type="button"
    role="tab"
    class="tab"
    [class.is-active]="isOverviewSelected"
    [attr.aria-selected]="isOverviewSelected"
    (click)="selectTab('overview')"
    [attr.data-cy]="'popup-tab-overview'"
  >
    <span class="tab__icon">
      <ng-container
        *ngTemplateOutlet="icon; context: { $implicit: 'overview' }"
      ></ng-container>
    </span>
    <span class="tab__label">Overview</span>
  </button>

  <button
    type="button"
    role="tab"
    class="tab"
    *ngFor="let tab of tabs; trackBy: trackById"
    [class.is-active]="activeTabId === tab.id"
    [attr.aria-selected]="activeTabId === tab.id"
    (click)="selectTab(tab.id)"
    [attr.data-cy]="'popup-tab-' + tab.id"
  >
    <span class="tab__icon">
      <ng-container
        *ngTemplateOutlet="icon; context: { $implicit: tab.icon }"
      ></ng-container>
      <span
        class="tab__lock"
        *ngIf="tab.lock"
        [class.is-free-lock]="tab.lock.free"
      >
        <svg appLockIcon></svg>
      </span>
    </span>
    <span class="tab__label">{{ tab.label }}</span>
  </button>
</nav>

<div class="panel" #panel role="tabpanel" [attr.data-cy]="'popup-panel'">
  <ng-container *ngIf="isOverview">
    <!-- The combined index, always against the country. The letter and its
         colour come from the same ramp the map paints the cell with. -->
    <section class="score" [attr.data-cy]="'popup-score'">
      <button
        type="button"
        class="score__grade score__grade--locked"
        *ngIf="heroLock"
        [class.is-free-lock]="heroLock.free"
        (click)="handleHeroLockedClick()"
        [attr.aria-label]="heroLock.aria + ' ' + heroTitle"
        [attr.data-cy]="'popup-score-locked'"
      >
        <span class="score__lock">
          <svg appLockIcon></svg>
        </span>
      </button>

      <div
        class="score__grade"
        *ngIf="!heroLock"
        [class.is-pending]="isScorePending"
        [style.color]="heroGrade ? heroGrade.ink : null"
        [attr.aria-busy]="isScorePending ? 'true' : null"
      >
        {{ isScorePending ? '' : heroGrade ? heroGrade.letter : '–' }}
      </div>

      <div class="score__body">
        <!-- The (?) carries what the caption used to spell out, and it is the
             same hint the right menu shows for this indicator. -->
        <p class="score__name">
          {{ heroTitle }}
          <app-feature-tooltip
            class="score__hint"
            [tooltipText]="scoreDescription"
            [featureName]="heroTitle"
            tooltipPosition="below"
            (openTooltipModal)="handleScoreHintClick($event)"
          ></app-feature-tooltip>
        </p>

        <!-- Two renderings of the same three grades. The meters are the roomy one;
           below 768px the bar is dropped and the letter carries the grade on its
           own, which is what the colour is keyed to anyway. -->
        <ul class="score__chips">
          <li *ngFor="let sub of subIndices">
            {{ sub.label }}
            <b
              [class.is-pending]="isSubIndexPending(sub)"
              [style.color]="sub.grade ? sub.grade.ink : null"
              >{{
                isSubIndexPending(sub)
                  ? '·'
                  : sub.locked
                    ? '•'
                    : sub.grade
                      ? sub.grade.letter
                      : '–'
              }}</b
            >
          </li>
        </ul>

        <ul class="score__meters">
          <li class="meter" *ngFor="let sub of subIndices">
            <span class="meter__label">{{ sub.label }}</span>
            <span
              class="meter__track"
              [class.is-pending]="isSubIndexPending(sub)"
            >
              <span
                class="meter__fill"
                [style.width.%]="sub.grade ? sub.grade.fill : 0"
                [style.background]="sub.grade ? sub.grade.base : null"
              ></span>
            </span>
            <span
              class="meter__grade"
              [class.is-pending]="isSubIndexPending(sub)"
              [style.color]="sub.grade ? sub.grade.ink : null"
              >{{
                isSubIndexPending(sub)
                  ? '·'
                  : sub.locked
                    ? '•'
                    : sub.grade
                      ? sub.grade.letter
                      : '–'
              }}</span
            >
          </li>
        </ul>

        <button
          type="button"
          class="score__caption score__caption--action"
          *ngIf="heroLock"
          [class.is-free-lock]="heroLock.free"
          (click)="handleHeroLockedClick()"
        >
          {{ heroLock.free ? 'Sign up free' : 'Unlock' }} to see the overall
          grade
        </button>
      </div>
    </section>

    <!-- The metric the map is coloured by right now: the answer to the click. -->
    <section
      class="focus"
      *ngIf="activeRow"
      [attr.data-cy]="'levels-popup-list'"
    >
      <!-- Name, number and gap on one line: this row is a caption for the map
           underneath, not the card's headline, and stacking it cost three lines
           of the panel's height budget for one metric. -->
      <div class="focus__line">
        <span class="focus__label">
          <span class="focus__name">{{ activeRow.label }}</span>
          <span class="focus__flag">on the map</span>
        </span>
        <span
          class="focus__value"
          *ngIf="!activeRow.lock"
          [attr.data-cy]="'levels-popup-list-value'"
          >{{
            activeRow.pending || (isLoading && activeRow.value === 'N/A')
              ? 'Loading'
              : activeRow.value
          }}</span
        >
        <!-- The layer the map is painted with, behind the paywall: the pinned
             row is the one place the visitor has already asked the question, so
             it says what is missing and offers the way to it. -->
        <button
          type="button"
          class="focus__value focus__unlock"
          *ngIf="activeRow.lock"
          [class.is-free-lock]="activeRow.lock.free"
          (click)="handleLockedClick(activeRow)"
          [attr.data-cy]="'levels-popup-list-value'"
          [attr.aria-label]="activeRow.lock.aria + ' ' + activeRow.label"
        >
          <span class="focus__lock">
            <svg appLockIcon></svg>
          </span>
          {{ activeRow.lock.phrase }}
        </button>
      </div>

      <!-- Same foot as every other row: the bar takes the slack, the gap sits
           in its own column, and the national figure right-aligns under the
           cell's own number. -->
      <div
        class="focus__foot"
        *ngIf="
          activeRow.deviation || (activeRow.reference && !activeLayerLevelNote)
        "
      >
        <span class="bar bar--wide" *ngIf="activeRow.deviation">
          <span class="bar__tick"></span>
          <span
            class="bar__fill"
            [ngClass]="'is-' + activeRow.deviation.polarity"
            [style.left.%]="fillOffset(activeRow.deviation)"
            [style.width.%]="fillWidth(activeRow.deviation)"
          ></span>
        </span>
        <span
          class="focus__delta"
          *ngIf="activeRow.deviation"
          [ngClass]="'is-' + activeRow.deviation.polarity"
          >{{ activeRow.deviation.label }}</span
        >
        <span
          class="focus__avg"
          *ngIf="activeRow.reference && !activeLayerLevelNote"
          >{{ activeRow.reference }}</span
        >
      </div>

      <p class="focus__ref" *ngIf="activeLayerLevelNote">
        {{ activeLayerLevelNote }}
      </p>
    </section>

    <section class="block" *ngIf="glance.length">
      <!-- Four plain numbers. The national comparison belongs on the rows
           below, where the US average is printed next to the value it is being
           compared with; up here it was four repetitions of the same phrase
           around figures most people read on their own. -->
      <h5 class="block__title">At a glance</h5>
      <ul class="glance">
        <li
          class="tile"
          *ngFor="let tile of glance; trackBy: trackByFeature"
          [class.is-on-map]="tile.onMap"
          [class.is-clickable]="tile.colorable && !tile.lock && !tile.onMap"
          [class.guide-highlight]="guidedFeature === tile.feature"
          [class.guide-highlight-pulse]="
            guidedFeature === tile.feature && guidedPulse
          "
        >
          <!-- Stretched over the tile rather than wrapped around it: the tile
               is a two-row grid, and a button in the middle of it would have to
               rebuild that layout to look identical. -->
          <button
            type="button"
            class="tile__hit"
            *ngIf="tile.colorable && !tile.lock && !tile.onMap"
            (click)="handleColorByClick(tile)"
            [attr.data-cy]="'popup-glance-action'"
            [attr.aria-label]="'Color the map by ' + tile.label"
          ></button>
          <span class="tile__icon">
            <ng-container
              *ngTemplateOutlet="icon; context: { $implicit: tile.icon }"
            ></ng-container>
          </span>
          <span
            class="tile__value"
            *ngIf="!tile.lock"
            [class.is-pending]="tile.pending"
            [attr.aria-busy]="tile.pending ? 'true' : null"
            >{{ tile.pending ? '···' : tile.value }}</span
          >
          <button
            type="button"
            class="tile__value tile__unlock"
            *ngIf="tile.lock"
            [class.is-free-lock]="tile.lock.free"
            (click)="handleLockedClick(tile)"
            [attr.data-cy]="'popup-locked-glance'"
            [attr.aria-label]="tile.lock.aria + ' ' + tile.label"
          >
            <span class="tile__lock">
              <svg appLockIcon></svg>
            </span>
            {{ tile.lock.cta }}
          </button>
          <span class="tile__caption">
            <span class="tile__caption-text">{{ tile.caption }}</span>
            <span class="tile__cursor" *ngIf="guidedFeature === tile.feature">
              <ng-container *ngTemplateOutlet="guideCursor"></ng-container>
            </span>
          </span>
        </li>
      </ul>
    </section>

    <section class="block" *ngIf="standouts.length">
      <h5 class="block__title">Furthest from the US average</h5>
      <ng-container *ngFor="let row of standouts; trackBy: trackByFeature">
        <ng-container
          *ngTemplateOutlet="metric; context: { $implicit: row }"
        ></ng-container>
      </ng-container>
    </section>
  </ng-container>

  <ng-container *ngIf="!isOverview && activeTab as tab">
    <section
      class="block"
      *ngFor="let section of tab.sections; trackBy: trackByIndex"
    >
      <h5 class="block__title" *ngIf="section.label">{{ section.label }}</h5>
      <p class="block__note" *ngIf="section.note">{{ section.note }}</p>
      <ng-container
        *ngIf="section.id === TRAFFIC_SECTION_ID"
        [ngTemplateOutlet]="trafficCard"
      ></ng-container>
      <ng-container
        *ngIf="section.id === CUSTOMERS_SECTION_ID"
        [ngTemplateOutlet]="generationsCard"
      ></ng-container>
      <app-traffic-teaser
        *ngIf="section.id === TRAFFIC_TEASER_SECTION_ID"
      ></app-traffic-teaser>
      <ng-container *ngFor="let row of section.rows; trackBy: trackByFeature">
        <ng-container
          *ngTemplateOutlet="metric; context: { $implicit: row }"
        ></ng-container>
      </ng-container>
    </section>
  </ng-container>
</div>
